const $itemCodeSearch = document.getElementById('itemcode-search');
const $itemCodeSearchBtn = document.getElementById('itemcode-search-btn');

const searchForItemCode = () => {
    if ($itemCodeSearch.value.length > 0) {
        window.location.href = `/picture-frame-mouldings/detail/Moulding/${$itemCodeSearch.value}`;
    }
}

$itemCodeSearchBtn.addEventListener('click', searchForItemCode);
$itemCodeSearch.addEventListener('keyup', (e) => {
    if (e.key === 'Enter') {
        searchForItemCode();
    }
});